export default __webpack_public_path__ + "static/frogs-f4cf57e2e881e5c1e074a1d8b1e447b2.jpg";